<template>
  <div class="core_wrap">
    <el-row class="core_options" type="flex" justify="space-between">
      <el-col
        class="core_items hidden-xs-only"
        v-for="(item, index) in coresList"
        :key="index"
        :class="item.isActive ? 'is_active' : ''"
        @click.native="changeCurrentIndex(index)"
        >
        <el-row ><div class="el-icon-s-cooperation core_items_icon"></div> </el-row>
        <el-row class="core_items_tit"> {{ item.tit }}</el-row>
       </el-col
      >
      <el-col
        class="core_items2 hidden-sm-and-up"
        v-for="(item, index) in coresList"
        :key="item.tit"
        :class="item.isActive ? 'is_active' : ''"
        @click.native="changeCurrentIndex(index)"
        >{{ item.tit }}</el-col
      >
    </el-row>
    <component :is="currentComponent[currentIndex]"></component>
  </div>
</template>

<script>
import CoreItemOne from './CoreItemOne.vue'
import CoreItemTwo from './CoreItemTwo.vue'
import CoreItemThree from './CoreItemThree.vue'
import CoreItemFour from './CoreItemFour.vue'
export default {
  data() {
    return {
      coresList: [
        {
          tit: '中考',
          isActive: true,
        },
        {
          tit: '职业高考',
          isActive: false,
        },
        {
          tit: '国际路线',
          isActive: false,
        },
        {
          tit: '职业就业',
          isActive: false,
        }

      ],
      currentIndex: 0,
      currentComponent:[CoreItemOne,CoreItemTwo,CoreItemThree,CoreItemFour]
    }
  },
  methods: {
    changeCurrentIndex(index) {
      this.currentIndex = index
      this.coresList.map((v, i) => {
        i === index ? (v.isActive = true) : (v.isActive = false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.core_wrap {
  width: 100%;
  margin-top: 50px;
  text-align: center;
  background-color: #f1f1f1;
  .core_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  .core_options {
    width: 40%;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .core_items {
      width: 25%;
      height: 160px;
      //border: solid 1px #04cac7;
      font-size: 15px;
      line-height: 70px;
      user-select: none;
      cursor: pointer;
      .core_items_icon {
        font-size: 40px;
        background-color: rgba(0,0,0,0.03);
        color: #003366;
        width: 90px;
        height: 50px;
        text-align: center;
        border-radius: 25px;
        padding-top: 5px;
        margin-top: 20px;
      }
      .core_items_tit {
        padding-bottom: 30px;
        height: 60px;
      }
    }
    .core_items2{
      width: 30%;
      height: 100PX;
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px #04cac7;
      padding: 5PX;
      font-size: 0.9rem;
    }
    .is_active {
      color: #fff;
      font-weight: bold;
      background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
      box-shadow: 0 0.5rem 1.5rem 0 rgb(0 135 168 / 50%);
      .core_items_icon {
        color: #fff;
      }
    }
  }
}
</style>